export const INSURANCE_COVERAGE_MAX_FILES = 15
